// ChargeConfirmDialog.jsx — 1:1급여 확정 요약 창 (2026-10-06 UX, 종전 window.confirm 대체)
//   "9월분 1:1급여 10명 · 합계 X원을 2026-10-01 정산서에 넣습니다" + 확정 뒤 무엇이 잠기는지 안내 → [확정하기]
import React from 'react';
import Modal from '../../../components/Modal';
import { stdBlackBtn, stdOutlineBtn } from '../adminlayout/designStandard';
import { fmtMoney } from './monthlyCalculationUtils';

const D = {
  body: { display: 'flex', flexDirection: 'column', gap: 10, fontSize: 14, color: 'var(--text)', lineHeight: 1.6 },
  big: { fontSize: 16, fontWeight: 800 },
  note: { fontSize: 13, color: 'var(--text-muted)' },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 8 },
};

export function ChargeConfirmDialog({ open, calc, onClose }) {
  if (!open) return null;
  const { year, month } = calc.parsedMonth;
  async function confirm() {
    const ok = await calc.submitConfirm();
    if (ok) onClose();
  }
  const footer = (
    <div style={D.footer}>
      <button type="button" style={stdOutlineBtn} onClick={onClose} disabled={calc.loading}>취소</button>
      <button type="button" style={{ ...stdBlackBtn, minHeight: 40 }} onClick={confirm} disabled={calc.loading}>
        {calc.loading ? '확정 중' : '확정하기'}
      </button>
    </div>
  );
  return (
    <Modal open title={`${month}월분 1:1급여 확정`} icon="✅" onClose={onClose} footer={footer} width="min(480px, calc(100vw - 48px))" mobileSheet>
      <div style={D.body}>
        <div style={D.big}>
          {year}년 {month}월분 1:1급여 {calc.rows.length}명 · 합계 {fmtMoney(calc.totals?.chargeAmount)}을
          {' '}{calc.settlementDate} 정산서에 넣습니다.
        </div>
        <div style={D.note}>
          확정하면 이 달의 넣기·빼기와 금액이 그대로 저장되고, 이 달에 쓰인 급여 조건도 잠겨요.
          바꾸려면 '확정 취소'를 누른 뒤 고치고 다시 확정하면 됩니다.
        </div>
        {calc.error && <div style={{ ...D.note, color: '#dc2626' }}>{calc.error}</div>}
      </div>
    </Modal>
  );
}
